import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import {useUsuarioMutations} from '../../hooks/usuarios/useUsuarioMutations'
import { FooterPages } from '..';

const initialState = {
  empresa:'',
  usuario: '',
  password:'123',
  nombre: '',
  telefono: '',
  email: '',
  idCentro: null,
  estado: 'Activo',
  rol: 'Partner',
  };

const NuevoUsuario = ({usuarioD, onChangeUsuario}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addUsuario, updateUsuario } = useUsuarioMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if(usuarioD) setFormData(usuarioD);
  }, [usuarioD]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones
 

    if(!usuarioD._id) 
    {
      const dataBase = {
        empresa:formData.empresa,
        usuario: formData.usuario,
        password: formData.password,
        nombre: formData.nombre,
        telefono: formData.telefono,
        email: formData.email,
        estado: formData.estado,
        rol: formData.rol
      };
      await addUsuario.mutateAsync( dataBase );
    } else
    {
        const dataBase = {
          _id: usuarioD._id,
          empresa:formData.empresa,
          usuario: formData.usuario,
          password: formData.password,
          nombre: formData.nombre,
          telefono: formData.telefono,
          email: formData.email,
          estado: formData.estado,
          rol: formData.rol
        };

       await updateUsuario.mutateAsync( dataBase );
    };

    onChangeUsuario('REFRESH');
    setIsClicked( !isClicked.nuevousuarios );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-2/3 p-8">
          
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!usuarioD ? "Nuevo" : "Editar"} Usuario
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevousuarios)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>
          
          <div className="mt-5 space-y-4">

          <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Usuario</label>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder="Usuario"
                      name="usuario"
                      value= {formData.usuario}
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-span-2">
                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Nombre</label>
                      <input
                          className={inputClass}
                          type="text"
                          placeholder="Nombre"
                          name="nombre"
                          value= {formData.nombre}
                          required
                          onChange={handleChange}
                        />
                  </div>
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Teléfono</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="Teléfono"
                        name="telefono"
                        value= {formData.telefono}
                        onChange={handleChange}
                      />
                  </div>  
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2" >
 
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">email</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="email"
                        name="email"
                        value= {formData.email}
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Rol</label>
                    <select className={inputClass} name="rol" value= {formData.rol} required onChange={handleChange}>
                    <option value="Administrador">Administrador</option>
                    <option value="Drop-off">Drop-off</option>
                    <option value="Partner">Partner</option>
                    <option value="Cliente">Cliente</option>
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Estado</label>
                    <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>
                      <option value="Activo">Activo</option>
                      <option value="Inactivo">Inactivo</option>
                      <option value="Eliminado">Eliminado</option>
                    </select>
                  </div>
              </div>

     
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                  <button
                      onClick={handleSubmit}
                      className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                  >
                    { !usuarioD ? "Crear Nuevo": "Guardar Cambios"}
                  </button>
              </div>      
              <FooterPages />  
              
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoUsuario;